import { NewzooToDatabrain } from '@intelligence/utils/constant';

export const DATASOURCE_NAME = {
  appannie: 'data.ai',
  appstore: 'AppStore',
  bilibili: 'Bilibili',
  crunchbase: 'Crunchbase',
  databarin: 'Databarin',
  ogdb: 'Databarin',
  epic: 'Epic',
  fbgaming: 'Fb Gaming',
  googleplay: 'GooglePlay',
  hatchet: 'Hatchet',
  mscience: 'M Science',
  newzoo: NewzooToDatabrain,
  nintendo: 'Nintendo',
  npd: 'NPD',
  playstation: 'Play Station',
  sensortower: 'Sensor Tower',
  steam: 'Steam',
  source_steam: 'Steam',
  steamcharts: 'Steam',
  taptap: 'Taptap',
  twitch: 'Twitch',
  xbox: 'Xbox',
  youtube: 'Youtube',
  steamdatabase: 'SteamDB',
  vginsights: 'VG Insights',
  famitsu: 'Famitsu',
  gsd: 'GSD',
  stream: 'Stream Hatchet',
  ampere: 'Other Vendor',
  gamalytic: 'Gamalytic',
  alinea: 'Alinea Analytics',
} as any;
